import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { CrudService } from "./crud.service";
import { StripeService } from "ngx-stripe";
import { switchMap } from "rxjs";
import { environment } from "src/environments/environment";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class PaymentService {
  constructor(
    private modalController: ModalController,
    private _crudService: CrudService,
    private stripeService: StripeService,
    private http: HttpClient,
    private auth: AuthService
  ) {}

  async openPaymentModal() {
    // Imported dynamically to break the PaymentService <-> PaymentComponent
    // module cycle (which caused a "Cannot access 'PaymentService' before
    // initialization" TDZ crash that cascaded through the unit-test suite).
    const { PaymentComponent } = await import(
      "../components/payment/payment.component"
    );
    const modal = await this.modalController.create({
      component: PaymentComponent,
    });
    await modal.present();
  }

  async registerZellePayment(file: File, referencia: string, valor: number) {
    const formData = new FormData();
    formData.append("Referencia", referencia);
    formData.append("Valor", String(valor));
    formData.append("Comprovante", file, file.name);

    const token = await this.auth.getToken();
    const headers: Record<string, string> = {};
    if (token) headers["Authorization"] = `Bearer ${token}`;

    return this.http.post(
      `${environment.API_BASE}api/pagamento/registrar-pagamento-zelle`,
      formData,
      { headers }
    );
  }
}
